import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, concatMap, map, tap} from 'rxjs/operators';
import {of} from 'rxjs';

import * as RetryProductionInstanceActions from '../actions/retry-production-instance.actions';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ProductionInstancesService} from '../../../services/api/production-instances/production-instances.service';
import {UUID} from '../../../shared/types/uuid.type';
import {ProductionInstance} from '../../../services/api/production-instances/production-instance.model';


@Injectable()
export class RetryProductionInstanceEffects {

  retryProductionInstance = createEffect(() => {
    return this.actions.pipe(
      ofType(RetryProductionInstanceActions.retryProductionInstance),
      concatMap((payload: { id: UUID }) =>
        this.productionInstancesService.retry(payload.id)
          .pipe(
            map((data: ProductionInstance) => RetryProductionInstanceActions.retryProductionInstanceSuccess({data})),
            catchError((error: any) => of(RetryProductionInstanceActions.retryProductionInstanceFailure({error})))
          )
      )
    );
  });

  // noinspection JSUnusedGlobalSymbols
  retryProductionInstanceSuccess = createEffect(() => {
    return this.actions
      .pipe(
        ofType(RetryProductionInstanceActions.retryProductionInstanceSuccess),
        tap(() => this.snackBar.open('Production instance retry action successfully started', 'Success', {duration: 3000}))
      );
  }, {dispatch: false});

  constructor(
    private readonly actions: Actions,
    private readonly productionInstancesService: ProductionInstancesService,
    private readonly snackBar: MatSnackBar
  ) {
  }

}
